import { PortalError } from './PortalError';

export class EventAlreadyExistsError extends PortalError {
  constructor() {
    super('EventAlreadyExistsError', 'There is already an event type with this timestamp', 'api_event_already_exists');
  }
}
